export default "__VITE_ASSET__DL95VkMK__"